import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const ACCENT = "#d04260";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F5F5F7] flex items-center justify-center p-6" data-testid="not-found-page">
      <Helmet>
        <title>Pagina non trovata — Hostland</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <img src="/hostland-logo.png" alt="Hostland" className="w-20 h-20 rounded-2xl mx-auto mb-6 object-cover" />
        <h1 className="text-6xl font-bold text-zinc-900 mb-2">404</h1>
        <p className="text-lg font-bold text-zinc-600 mb-1">Pagina non trovata</p>
        <p className="text-sm text-zinc-400 mb-8">La pagina che stai cercando non esiste o è stata spostata.</p>
        <div className="flex items-center justify-center gap-3">
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white border border-zinc-200 text-zinc-700 font-bold text-sm hover:bg-zinc-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />Indietro
          </motion.button>
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate("/")}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-white font-bold text-sm hover:opacity-90 transition-all"
            style={{ background: ACCENT }}
          >
            <Home className="w-4 h-4" />Home
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
